module.exports = __webpack_public_path__ + "media/bootstrap-icons/octagon-half-7e23354c.svg";